import {rpAppLink} from "@pg-mono/rp-routes";

import {rpCommonUrl} from "../../../../app/read_rp_environment_variables";
import {TRANSACTION_PRICES_SOURCE_NAME_GENITIVE} from "../../constants/transaction_prices";
import {getRcnPeriodEndDate} from "../../utils/format_rcn_period_label";
import {ITransactionPriceRow} from "../../utils/get_transaction_price_rows";
import {getTransactionPricesPeriodLabel, ITransactionPricesSummary} from "../../utils/get_transaction_prices_summary";

interface IProps {
    rows: ITransactionPriceRow[];
    summary: ITransactionPricesSummary;
    offerMonthLabel: string | null;
}

export const PricesHubSchemaDataset = (props: IProps) => {
    const {rows, summary, offerMonthLabel} = props;
    const periodEndDate = getRcnPeriodEndDate(summary.latestPeriodStart, summary.latestPeriodLabel) ?? summary.latestPeriodStart;
    const isTotal = rows[0]?.unit === "total";

    const json = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: "Ceny mieszkań w Polsce – ceny ofertowe i transakcyjne w największych miastach",
        description: `Zestawienie średnich cen ofertowych z RynekPierwotny.pl${offerMonthLabel ? ` (${offerMonthLabel})` : ""} i średnich ucinanych cen transakcyjnych z ${TRANSACTION_PRICES_SOURCE_NAME_GENITIVE} za okres ${getTransactionPricesPeriodLabel(summary)}, w zł za m² na rynku pierwotnym, w ${rows.length} miastach Polski.`,
        url: `${rpCommonUrl}${rpAppLink.prices.flats.base()}`,
        inLanguage: "pl-PL",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: rpCommonUrl
        },
        isBasedOn: "https://geoportal.gov.pl",
        temporalCoverage: `${summary.earliestPeriodStart}/${periodEndDate}`,
        spatialCoverage: rows.map((row) => ({
            "@type": "City",
            name: row.name
        })),
        variableMeasured: [
            {"@type": "PropertyValue", name: isTotal ? "Średnia cena ofertowa" : "Średnia cena ofertowa za m²", unitText: isTotal ? "PLN" : "PLN/m²"},
            {
                "@type": "PropertyValue",
                name: isTotal ? "Średnia cena transakcyjna" : "Średnia cena transakcyjna za m²",
                description: "Średnia ucinana – bez 5% najtańszych i 5% najdroższych transakcji z kwartału",
                unitText: isTotal ? "PLN" : "PLN/m²"
            },
            {"@type": "PropertyValue", name: "Różnica", unitText: "%"}
        ],
        keywords: ["ceny mieszkań", "ceny transakcyjne", "ceny ofertowe", "rynek pierwotny", "Rejestr Cen Nieruchomości"]
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {rpCommonUrl} from "../../../../app/read_rp_environment_variables";
import {TRANSACTION_PRICES_SOURCE_NAME_GENITIVE} from "../../constants/transaction_prices";
import {getRcnPeriodEndDate} from "../../utils/format_rcn_period_label";
import {ITransactionPriceRow} from "../../utils/get_transaction_price_rows";
import {getTransactionPricesPeriodLabel, ITransactionPricesSummary} from "../../utils/get_transaction_prices_summary";

interface IProps {
    rows: ITransactionPriceRow[];
    summary: ITransactionPricesSummary;
    offerMonthLabel: string | null;
}

export const PricesHubSchemaDataset = (props: IProps) => {
    const {rows, summary, offerMonthLabel} = props;
    const periodEndDate = getRcnPeriodEndDate(summary.latestPeriodStart, summary.latestPeriodLabel) ?? summary.latestPeriodStart;
    const isTotal = rows[0]?.unit === "total";

    const json = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: "Ceny mieszkań w Polsce – ceny ofertowe i transakcyjne w największych miastach",
        description: `Zestawienie średnich cen ofertowych z RynekPierwotny.pl${offerMonthLabel ? ` (${offerMonthLabel})` : ""} i średnich ucinanych cen transakcyjnych z ${TRANSACTION_PRICES_SOURCE_NAME_GENITIVE} za okres ${getTransactionPricesPeriodLabel(summary)}, w zł za m² na rynku pierwotnym, w ${rows.length} miastach Polski.`,
        url: `${rpCommonUrl}${rpAppLink.prices.flats.base()}`,
        inLanguage: "pl-PL",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: rpCommonUrl
        },
        isBasedOn: "https://geoportal.gov.pl",
        temporalCoverage: `${summary.earliestPeriodStart}/${periodEndDate}`,
        spatialCoverage: rows.map((row) => ({
            "@type": "City",
            name: row.name
        })),
        variableMeasured: [
            {"@type": "PropertyValue", name: isTotal ? "Średnia cena ofertowa" : "Średnia cena ofertowa za m²", unitText: isTotal ? "PLN" : "PLN/m²"},
            {
                "@type": "PropertyValue",
                name: isTotal ? "Średnia cena transakcyjna" : "Średnia cena transakcyjna za m²",
                description: "Średnia ucinana – bez 5% najtańszych i 5% najdroższych transakcji z kwartału",
                unitText: isTotal ? "PLN" : "PLN/m²"
            },
            {"@type": "PropertyValue", name: "Różnica", unitText: "%"}
        ],
        keywords: ["ceny mieszkań", "ceny transakcyjne", "ceny ofertowe", "rynek pierwotny", "Rejestr Cen Nieruchomości"]
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
